export const INSTANCE_STATUSES = {
    NOT_STARTED: { label: 'Not Started', color: 'secondary' },
    IN_PROGRESS: { label: 'In Progress', color: 'default' },
    AWAITING_ADMIN: { label: 'Awaiting Review', color: 'warning' },
    COMPLETED: { label: 'Completed', color: 'default' },
    CANCELLED: { label: 'Cancelled', color: 'destructive' },
    OVERDUE: { label: 'Overdue', color: 'destructive' },
};

export const STEP_STATUSES = {
    NOT_STARTED: { label: 'Not Started', color: 'secondary' },
    IN_PROGRESS: { label: 'In Progress', color: 'default' },
    BLOCKED: { label: 'Blocked', color: 'destructive' },
    COMPLETED: { label: 'Completed', color: 'default' },
    PENDING_APPROVAL: { label: 'Pending Approval', color: 'warning' },
};

export const SOURCE_TYPES = {
    ADMIN_ASSIGNED: { label: 'Admin Assigned' },
    TENANT_REQUESTED: { label: 'Tenant Requested' },
    ONBOARDING: { label: 'Onboarding' },
    SYSTEM: { label: 'System' },
};

export const ACTIVE_STATUSES = ['NOT_STARTED', 'IN_PROGRESS', 'AWAITING_ADMIN'];
